import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the uploadCameraMedia state domain
 */

const selectUploadCameraMediaDomain = state =>
  state.uploadCameraMedia || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectUploadCameraMediaDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectUploadCameraMediaDomain,
    substate => substate.error,
  );

const makeSelectUploadedFile = () =>
  createSelector(
    selectUploadCameraMediaDomain,
    substate => substate.uploadedFile,
  );
const makeSelectUploadedFileType = () =>
  createSelector(
    selectUploadCameraMediaDomain,
    substate => substate.uploadedFileType,
  );

/**
 * Default selector used by UploadCameraMedia
 */

const makeSelectUploadCameraMedia = () =>
  createSelector(
    selectUploadCameraMediaDomain,
    substate => substate,
  );

// export default makeSelectUploadCameraMedia;
export {
  makeSelectUploadCameraMedia,
  selectUploadCameraMediaDomain,
  makeSelectError,
  makeSelectLoading,
  makeSelectUploadedFile,
  makeSelectUploadedFileType,
};
